import Vue from "vue";
import Router from "vue-router";
import { ADD_TOAST_MESSAGE } from "vuex-toast";
import common from './libs/common';
import webStorage from '@/libs/webStorage';
import i18n from './i18n';

Vue.use(Router);

const checkAuth = async (to, from, next, store, name) => {
  // store is bind to this
  try {
    const user = await store.dispatch("auth/checkAuth");
    // if (user.passwordChanged == false && name !== 'passwordSetting') {
    //   next({ name: "passwordSetting" });
    // } else if (common.checkRole(name, user)) {
    if (common.checkRole(name, user)) {
      next();
    } else {
      // webStorage.set('LAST_URL', to.fullPath);
      store.dispatch(
        ADD_TOAST_MESSAGE,
        { text: "Permission denied", type: "danger" },
        { root: true }
      );
      next({ name: "login" });
    }
  } catch (e) {
    // webStorage.set('LAST_URL', to.fullPath);
    Vue.$log.error("Login error", e);
    next({ name: "login" });
  }
};

export default store => {
  const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "login" */ "./views/Auth/Login.vue"),
        meta: { theme: "auth", title: i18n.t('login.sign_in'), login: true }
      },
      {
        path: "/download",
        name: "download",
        component: () =>
          import(/* webpackChunkName: "download" */ "./views/Download/Download.vue"),
        meta: { theme: "auth", title: "Download template", login: false }
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "register" */ "./views/Auth/Register.vue"),
        meta: { theme: "auth", title: i18n.t('login.register'), login: true }
      },
      {
        path: "/register/success",
        name: "registerSuccess",
        component: () =>
          import(/* webpackChunkName: "register" */ "./views/Auth/Success.vue"),
        meta: { theme: "auth", title: "Download", login: false }
      },
      {
        path: "/sso",
        name: "registerActive",
        component: () =>
          import(/* webpackChunkName: "register" */ "./views/Auth/RegisterActive.vue"),
        meta: { theme: "auth", title: i18n.t('login.register_active'), login: true }
      },
      {
        path: "/password-setting",
        name: "passwordSetting",
        component: () =>
          import(/* webpackChunkName: "passwordSetting" */ "./views/Auth/PasswordSetting.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, 'passwordSetting'),
        meta: { theme: "auth", title: "Update Password", login: true }
      },
      {
        path: "/password/reset",
        name: "forgotPassword",
        component: () =>
          import(/* webpackChunkName: "forgotPassword" */ "./views/Auth/ResetPassword.vue"),
        meta: { theme: "auth", title: "Reset Password", login: false }
      },
      {
        path: "/setting",
        name: "setting",
        component: () =>
          import(/* webpackChunkName: "profile" */ "./views/Profile/Setting.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "setting"),
        meta: { theme: "default", title: "Setting", activeMenu: "setting" }
      },
      {
        path: "/profile",
        name: "profile",
        component: () =>
            import(/* webpackChunkName: "profile" */ "./views/Profile/Profile.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "profile"),
        meta: { theme: "default", title: "Profile", activeMenu: "profile" }
      },
      {
        path: "/stock",
        name: "stockInfo",
        component: () =>
          import(/* webpackChunkName: "stock" */ "./views/Stock/components/Show.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "stockInfo"),
        meta: { theme: "default", title: "Stock info", activeMenu: "stock_info" }
      },
      {
        path: "/stock/overview",
        name: "overview",
        component: () =>
          import(/* webpackChunkName: "stock" */ "./views/Stock/Overview.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "overview"),
        meta: { theme: "default", title: "Overview", activeMenu: "overview" }
      },
      {
        path: "/ranking/general",
        name: "rankGeneral",
        component: () =>
          import(/* webpackChunkName: "ranking" */ "./views/Ranking/pages/General.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "rankGeneral"),
        meta: { theme: "default", title: "Ranking by General", activeMenu: "ranking" }
      },
      {
        path: "/ranking/10x-income",
        name: "rank10xIncome",
        component: () =>
          import(/* webpackChunkName: "ranking" */ "./views/Ranking/pages/10xIncome.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "rank10xIncome"),
        meta: { theme: "default", title: "Ranking by Owner income", activeMenu: "ranking" }
      },
      {
        path: "/ranking/dcf",
        name: "rankDcf",
        component: () =>
          import(/* webpackChunkName: "ranking" */ "./views/Ranking/pages/Dcf.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "rankDcf"),
        meta: { theme: "default", title: "Ranking by DCF", activeMenu: "ranking" }
      },
      {
        path: "/ranking/dca",
        name: "rankDca",
        component: () =>
          import(/* webpackChunkName: "ranking" */ "./views/Ranking/pages/Dca.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "rankDca"),
        meta: { theme: "default", title: "Ranking by DCA", activeMenu: "ranking" }
      },
      {
        path: "/ranking/dividend",
        name: "rankDividend",
        component: () =>
          import(/* webpackChunkName: "ranking" */ "./views/Ranking/pages/Dividend.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "rankDividend"),
        meta: { theme: "default", title: "Ranking by Dividend", activeMenu: "ranking" }
      },
      {
        path: "/market",
        name: "market",
        component: () =>
          import(/* webpackChunkName: "market" */ "./views/Market/Main.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "market"),
        meta: { theme: "default", title: "Market", activeMenu: "market" }
      },
      {
        path: "/market/sector",
        name: "marketSector",
        component: () =>
          import(/* webpackChunkName: "market" */ "./views/Market/Sector.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "marketSector"),
        meta: { theme: "default", title: "Market's sector", activeMenu: "marketSector" }
      },
      {
        path: "/upgrade",
        name: "upgrade",
        component: () =>
          import("./views/Payment/Main.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "payment"),
        meta: { theme: "default", title: "Upgrade", activeMenu: "payment" }
      },
      {
        path: "/survey",
        name: "survey",
        component: () =>
          import("./views/Survey/Main.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "survey"),
        meta: { theme: "default", title: "Survey", activeMenu: "survey" }
      },
      // {
      //   path: "/vp/create",
      //   name: "create_vp",
      //   component: () =>
      //     import("./views/Home/Portfolio/CreatePortfolio.vue"),
      //   beforeEnter: (...args) => checkAuth(...args, store, "vp"),
      //   meta: { theme: "default", title: "Virtual Portfolio", activeMenu: "vp" }
      // },
      {
        path: "/",
        name: "index",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/Home/Index.vue"),
        beforeEnter: (...args) => checkAuth(...args, store, "index"),
        meta: { theme: "default", title: "Home", activeMenu: "index" }
      },
      {
        path: "*",
        name: "error404",
        component: () =>
          import(/* webpackChunkName: "errors" */ "./views/Error/404.vue"),
        meta: { theme: "default", title: "404 page", activeMenu: "*" }
      },
    ]
  });

  // This callback runs before every route change, including on page load.
  router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
      el => el.parentNode.removeChild(el)
    );

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
      .map(tagDef => {
        const tag = document.createElement("meta");

        Object.keys(tagDef).forEach(key => {
          tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute("data-vue-router-controlled", "");

        return tag;
      })
      // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));

    next();
  });

  return router;
}
